const PREFIX = 'landgraf:quiz:';

export const getQuizProgress = (quizId) => {
    try {
        const raw = sessionStorage.getItem(`${PREFIX}${quizId}`);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const saveQuizProgress = (quizId, { completed, score, total }) => {
    try {
        const prev = getQuizProgress(quizId);
        const bestScore = Math.max(prev?.bestScore ?? 0, score);
        sessionStorage.setItem(
            `${PREFIX}${quizId}`,
            JSON.stringify({
                completed: completed || prev?.completed,
                bestScore,
                lastScore: score,
                total,
            })
        );
    } catch {
        // ignore quota errors
    }
};

export const getStarsFromScore = (score, total) => {
    if (!total) return 0;
    const pct = score / total;
    if (pct >= 0.9) return 3;
    if (pct >= 0.6) return 2;
    if (pct > 0) return 1;
    return 0;
};
